<template>
    <div class="component-form-title">
        <div class="title-box title-inviter" v-if="!!isInviter">
        <img class="title-img" :src="userInfo.head_image || userImgUrl">
        <div class="title-user">
            <strong>{{ userInfo.nickname || '蔚来用户' }}</strong> 邀您{{mode==='leads'?'体验蔚来':'预约试驾'}}
        </div>
    </div>
    </div>
</template>

<script>
import userImgUrl from '../../../assets/images/user@2x.png';
export default {
    props: {
        account: {
            type: Object,
            default: () => {
                return {
                    user: '',
                    nickname: ''
                };
            }
        },
        mode: {
            type: String,
            default: 'leads'
        }
    },
    methods: {},
    computed: {
        isInviter() {
            if (this.account.user) {
                return true;
            }
            return false;
        },
        userInfo() {
            if (this.account.user) {
                return this.account.user;
            }
            return this.account;
        },
        userImgUrl() {
            return userImgUrl;
        }
    },
    components: {}
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';
.component-form-title {
    font-size: 20 * @layout375;
    color: #363c54;
    .title-box {
        display: flex;
        flex-direction: column;
        padding: 0 25 * @layout375;
        border-radius: 10 * @layout375 10 * @layout375 0 0;
        &.title-inviter {
            text-align: center;
            align-items: center;
            background: linear-gradient(
                360deg,
                rgba(236, 245, 255, 1) 0%,
                rgba(255, 255, 255, 1) 100%
            );
            .title-img {
                width: 58 * @layout375;
                height: 58 * @layout375;
                margin-top: -29 * @layout375;
                margin-bottom: 20 * @layout375;
                border-radius: 29 * @layout375;
                border: 2px solid #fff;
            }
            .title-user {
                font-size: 23 * @layout375;
                margin-bottom: 30 * @layout375;
                white-space: normal;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/views/marketing/components/inviter-info.vue